import React from "react";
import locale from "locale";
import { getColumnColor } from '../models';
import { Table, Button, Checkbox } from "react-bootstrap";
import { useSheetsContext } from './RegistrationFieldsTable';
import { CUSTOM_VALUE, MAX_EXCEL_PREVIEW_ROWS } from '../constants';

const validateEmail = (email) => {
    return !!String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

const ImportedFileFieldsTable = ({ sheets, columns, onImport }) => {

    const {state, getColumns, updateState} = useSheetsContext();

    function handleImport() {
        if (!state.participationType) {
            alert('Выберите формат участия');

            return;
        }

        const payload = {
            role: state.role,
            participationType: state.participationType,
            sendMail: state.sendMail,
            termsAgree: true,
            users: [],
        };

        payload.users = state.sheet
            .slice(state.selectedRow)
            .reduce((acc, row) => {
                const rowData = Object.entries(state.selectedColumns).reduce((fields, [fieldName, columnIndex]) => {
                    if (columnIndex === CUSTOM_VALUE) {
                        fields[fieldName] = state.customValues[fieldName];
                    } else {
                        fields[fieldName] = ['string', 'number'].includes(typeof columnIndex) && +columnIndex >= 0 ? row[columnIndex] : null;
                    }

                    return fields;
                }, {});

                if (!rowData.email || typeof rowData.email !== 'string') return acc;
                
                const email = rowData.email.replaceAll(' ', '').toLowerCase();

                if (validateEmail(email)) {
                    acc.push({...rowData, email});
                }
                
                return acc;
            }, [])
            .filter((item) => Object.values(item).some((val) => !!val));

        onImport(payload);
    }

    return (
        <>
            <div className="sheetTableContainer">
                <Table>
                    <thead>
                        <tr>
                            <th width="40" />
                            {
                                getColumns().map((name, index) => (
                                    <th key={index}>{name}</th>
                                ))
                            }
                        </tr>
                    </thead>
                    <tbody>
                        {state.sheet
                            .slice(0, MAX_EXCEL_PREVIEW_ROWS)
                            .map((row, rowIndex) => (
                                <tr
                                    key={rowIndex}
                                    className={
                                        (rowIndex >= state.selectedRow
                                            ? "selectedRow"
                                            : "") +
                                        (rowIndex === state.selectedRow
                                            ? " selectedRowFirst"
                                            : "")
                                    }
                                >
                                    <td>{rowIndex + 1}</td>
                                    {getColumns().map((_, colIndex) => (
                                        <td
                                            key={colIndex}
                                            className={
                                                Object.values(state.selectedColumns).includes(colIndex)
                                                    ? "selectedColumn"
                                                    : ""
                                            }
                                            style={{
                                                backgroundColor: Object.values(state.selectedColumns).includes(colIndex)
                                                    ? getColumnColor(Object.values(state.selectedColumns).findIndex(v => v === colIndex))
                                                    : 'transparent'
                                            }}
                                        >
                                            {row[colIndex] || null}
                                        </td>
                                    ))}
                                </tr>
                            ))}
                    </tbody>
                </Table>
            </div> 
            <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                <Button
                    bsStyle="primary"
                    onClick={handleImport}
                >
                    {locale("reminders.apply")}
                </Button>
                <Checkbox
                    inline
                    checked={state.sendMail}
                    onChange={(e) => updateState({sendMail: e.target.checked})}
                >
                    {locale("importExcel.modal.sendRegistrationLetter")}
                </Checkbox>
            </div>
        </>
    );
};

export default ImportedFileFieldsTable;
